import { _ } from "../../polyglot/polyglot.js";

/**
 * Renders the cancel button of the footer
 *
 * @param {function} cancelCallback - Callback to cancel and abort the wizard action
 */
export function makeCancelButtonRenderer({ cancelCallback }) {
	return (html) => {
		html.div(
			{ klass: "form-group wizard-cancel" },
			buttonRenderer({
				label: _("Cancel"),
				action: () => cancelCallback(),
				cssClass: "btn-default",
				dataTest: "wizard-cancel",
			}),
		);
	};
}

/**
 * Renders the previous button of the footer
 *
 * @param {Wizard} wizard - Wizard to act upon
 */
export function makePreviousButtonRenderer({ wizard }) {
	return buttonRenderer({
		enabled: wizard.canGoToPreviousStep(),
		label: _("Previous"),
		action: () => wizard.goToPreviousStep(),
		cssClass: "btn-default",
		dataTest: "previous",
	});
}

/**
 * Renders the next button of the footer
 *
 * @param {Wizard} wizard - Wizard to act upon
 */
export function makeNextButtonRenderer({ wizard }) {
	return buttonRenderer({
		enabled: wizard.canSubmitCurrentStep(),
		label: nextButtonLabel({ wizard }),
		action: () => wizard.submitCurrentStep(),
		cssClass: "btn-primary btn-next",
		dataTest: "next",
	});
}

function buttonRenderer({ enabled = true, label, action, cssClass, dataTest }) {
	return (html) => {
		const disabled = !enabled;

		html.a(
			{
				klass: ["btn", cssClass, { disabled }],
				"data-test": dataTest,
				disabled,
				click: action,
			},
			label,
		);
	};
}

function nextButtonLabel({ wizard }) {
	const exceptionCollector = wizard.currentStepSubmitExceptions();

	if (exceptionCollector.isEmpty()) {
		return wizard.isAtLastStep() ? _("Done") : _("Next");
	}

	return _("Try again");
}
